import React__default from 'react';
import { View } from '@aws-amplify/ui-react';

function Container({ children, className, }) {
    return React__default.createElement(View, { className: className }, children);
}

export { Container };
